import { useAppSelector } from 'hooks/hooks';
import React, { PropsWithChildren, useMemo, useState } from 'react';
import { isGameAdmin } from 'slices/ActiveGameSlice';
import { getActiveTab } from 'slices/AppUiSlice';
import { TabPanel } from 'types/SqGame.types';
import styles from './GameAdminPanel.module.scss';

type GameAdminPanelOwnProps = {
  className?: string;
};

type GameAdminPanelProps = PropsWithChildren<GameAdminPanelOwnProps>;

const GameAdminPanel: React.FC<GameAdminPanelProps> = ({ className = '', children }) => {
  const baseCls = `${styles.GameAdminPanelContainer} ${className}`;
  const isAdmin = useAppSelector(isGameAdmin);
  const activeTab = useAppSelector(getActiveTab);
  const [show, setShow] = useState<boolean>(true);
  const visibleCls = show ? styles.Show : styles.Hide;



  const renderAdminPanelTitle = () => {
    return (
      <div onClick={() => setShow(!show)} className={styles.Title}>
        ADMIN PANEL
      </div>
    );
  };

  const showAdminPanel = useMemo(() => {
    return isAdmin && activeTab === TabPanel.Scoreboard;
  }, [isAdmin, activeTab]);

  return (
    <>
      {showAdminPanel && (
        <div className={`${baseCls} ${visibleCls}`}>
          {renderAdminPanelTitle()}
          {children}
        </div>
      )}
    </>
  );
};

export default GameAdminPanel;
